import { defaultIconColor } from './constants';
import { SVGComponentPropsType } from './types';

export default ({ color = defaultIconColor, ...props }: Omit<SVGComponentPropsType, 'size'>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="9" height="14" {...props}>
    <path d="M1 1l6 6-6 6" stroke={color} strokeWidth="2" fill="none" fillRule="evenodd" />
  </svg>
);
